import 'bootstrap';

// protect against double loading (caused by lodash-es for some reason)
if (!window.mainIndexLoaded) {
    window.mainIndexLoaded = true;

    // load for all normal pages
    if (document.querySelector('body.Page')) {
        import('./up-arrow').then();
        import('./vh').then();
        import('./scroll-hide').then();
        import('./search-helper').then();
        // import('./dialog').then();
    }
    
    // animate-on-visible
    if (document.querySelector('[data-animate-on-visible]')) {
        import('./animate-on-visible').then();
    }
    
    // counterup-helper
    if (document.querySelector('[data-counterup]')) {
        import('./counterup-helper').then();
    }
    
    // progress-ring-helper
    if (document.querySelector('progress-ring')) {
        import('./progress-ring-helper');
    }
    
    // testimonials
    if (document.querySelector('[data-testimonials]')) {
        import('./testimonials');
    }
    
    // svg-injector-helper
    if (document.querySelector('[data-svg-inject]')) {
        import('./svg-injector-helper').then();
    }
    
    // cachebust-src
    if (document.querySelector('[data-cachebust-src]')) {
        import('./cachebust-src').then();
    }
    
    // focuspoint-helper
    if (document.querySelector('[data-focus-x]')) {
        import('./focuspoint-helper').then();
    }
    
    // sitewide-popup
    if (document.querySelector('[data-sitewide-popup-type]')) {
        import('./sitewide-popup').then();
    }
    
    // video-modal.js
    if (document.querySelector('[data-video-modal]')) {
        import(/* webpackChunkName: "video-modal" */ './video-modal').then();
    }
    
    // modal-helper.js
    if (document.querySelector('[data-modal]')) {
        import(/* webpackChunkName: "modal-helper" */ './modal-helper').then();
    }
    
    // slider
    if (document.querySelector('[data-slider]')) {
        import('./slider').then();
    }
    
    // slick-helper
    if (document.querySelector('[data-slick]')) {
        import('./slick-helper').then();
    }
    
    // ticker
    if (document.querySelector('[data-ticker]')) {
        import('./ticker').then();
    }
    
    // providerfinder
    if (document.querySelector('[data-providerfinder]')) {
        import('./providerfinder/index').then();
    }
    
    // limited
    if (document.querySelector('[data-limited]')) {
        import('./limited').then();
    }
    
    // file-input
    if (document.querySelector('.field.file input[type="file"]')) {
        import('./file-input').then();
    }
    
    // required-label
    if (document.querySelector('[required]')) {
        import('./required-label').then();
    }
    
    // tabs
    if (document.querySelector('[data-tab-list]')) {
        import('./tabs').then();
    }
    
    // tag
    if (document.querySelector('[data-tag]')) {
        import('./tag').then();
    }
    
    // cards
    if (document.querySelector('[data-offscreen]')) {
        import('./offscreen').then();
    }
    
    // fader-items
    if (document.querySelector('[data-fader-items]')) {
        import('./fader-items').then();
    }
    
    // speedbumps
    if (document.querySelector('[data-speedbumps]')) {
        import('./speedbumps').then();
    }
    
    // webtolead
    if (document.querySelector('[data-webtolead]')) {
        import('./webtolead').then();
    }
    
    // default-country
    if (document.querySelector('select.dropdown.-default-country')) {
        import('./default-country').then();
    }
    
    // background-video
    if (document.querySelector('[data-vbg]')) {
        import('./background-video').then();
    }
    
    
    // // click-video
    // if (document.querySelector('[data-click-video]')) {
    //     import('./click-video').then();
    // }
    
    // norobots
    if (document.querySelector('[data-norobot]')) {
        import('./norobot').then();
    }
}    
